/* tslint:disable */

declare var Object: any;
export interface SFEmployeePayrollDataInterface {
  "id"?: number;
}

export class SFEmployeePayrollData implements SFEmployeePayrollDataInterface {
  "id": number;
  constructor(data?: SFEmployeePayrollDataInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFEmployeePayrollData`.
   */
  public static getModelName() {
    return "SFEmployeePayrollData";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFEmployeePayrollData for dynamic purposes.
  **/
  public static factory(data: SFEmployeePayrollDataInterface): SFEmployeePayrollData{
    return new SFEmployeePayrollData(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFEmployeePayrollData',
      plural: 'SFEmployeePayrollData',
      path: 'SFEmployeePayrollData',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFEmployeePayrollData.ts